"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  name: "Geroi.it",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/logo_partner_tech_1.png"
}, {
  name: "Industrial Logistics",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/logo_partner_finance_2.png"
}, {
  name: "Global Supply Chain",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/logo_partner_creative_3.png"
}, {
  name: "Maritime Cargo",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/logo_partner_eco_4.png"
}, {
  name: "Customs Elite",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/logo_partner_logistics_5.png"
}, {
  name: "Strategic Rail",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/logo_partner_build_6.png"
}, {
  name: "Air Freight Pro",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/logo_partner_health_7.png"
}, {
  name: "Euro Hub",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/logo_partner_media_8.png"
}];
export default function TheyBelievedInUs() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="84920" id="certificazioni-e-network" className="bg-[#0A0A0A] py-24 md:py-32 overflow-hidden" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="flex flex-col md:flex-row gap-12 md:gap-24 items-center md:items-stretch">
          
          {}
          <div className={`hidden md:flex items-center justify-center shrink-0 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <h2 className="text-6xl lg:text-8xl font-serif font-black tracking-tighter text-white uppercase [writing-mode:vertical-rl] rotate-180 m-0 leading-none">
              Network
            </h2>
          </div>

          {}
          <div className="md:hidden w-full text-left">
            <h2 className="text-5xl font-serif font-black tracking-tighter text-white uppercase">
              Network
            </h2>
            <p className="text-secondary mt-2 text-lg font-sans">Certificazioni & Alleanze Strategiche</p>
          </div>

          {}
          <div className={`flex-1 w-full transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-secondary/20 border-y border-secondary/40 rounded-none overflow-hidden">
              {partners.map((partner, i) => <div key={i} data-index={i} className="bg-[#0A0A0A] aspect-square flex items-center justify-center p-8 group relative overflow-hidden">
                  <img src={partner.logo} alt={`Logo ${partner.name}`} className="max-w-[120px] w-full h-auto object-contain grayscale opacity-40 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700 ease-in-out transform group-hover:scale-110" loading="lazy" />
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}